<div
  [class.animate-dialog]="animateDialog()"
  [ngClass]="dialogStyle().includes('offset') ? 'offset' : 'default'"
  class="uk-position-fixed dialog-overlay">
  <div
    #dialog
    [ngClass]="[dialogStyle(), dialogBackground() || 'custom-white'] | compactClass"
    class="uk-position-relative dialog-container">
    <div [ngClass]="dialogBackground() || 'custom-muted'" class="dialog-title-wrap uk-flex uk-flex-row uk-flex-center uk-flex-between">
      @if (dialogTitle()) {
        <div class="dialog-title">{{ dialogTitle() }}</div>
      }
      <mat-icon (click)="closeDialog()" class="uk-position-absolute close-button" svgIcon="mdi:close" />
    </div>
    <div class="dialog-content overflow-y-auto">
      <ng-template tessDialogInsertion />
    </div>
  </div>
</div>
